export enum ChatTypesEnum {
  App = "app",
  Nutrition = "nutrition",
  Workout = "workout",
  Coaching = "coaching",
}
